<template>
  <div>
    <!-- SP表示 -->
    <!-- 通常コースのバッジ -->
    <a
      class="absolute block w-full md:hidden"
      href="#careerup"
      :style="{ bottom: '0', left: '0' }"
      @click.prevent="scrollTo('careerup')"
    >
      <img
        class="w-full"
        src="~/assets/images/Te/TeCommon/Badge/Reskilling/reskilling_ai_sp.webp"
        alt="経済産業省認定講座受講料最大70%キャッシュバック！"
      >
    </a>

    <!-- PC表示 -->
    <!-- 通常コースのバッジ -->
    <a
      class="absolute hidden md:block"
      href="#careerup"
      :style="{ right: '1.25rem', bottom: '1.25rem' }"
      @click.prevent="scrollTo('careerup')"
    >
      <img
        src="~/assets/images/Te/TeCommon/Badge/Reskilling/reskilling.webp"
        alt="経済産業省認定受講料最大70%キャッシュバック"
        width="126"
        height="124"
      >
    </a>
  </div>
</template>
